var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 22,
    height: 22,
    rx: 11,
    fill: "#F1F4F9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.04323 11.3725C6.80458 11.1322 6.41764 11.1322 6.17899 11.3725C5.94034 11.6129 5.94034 12.0025 6.17899 12.2428L9.23455 15.3198C9.4732 15.5601 9.86013 15.5601 10.0988 15.3198L16.821 8.55053C17.0597 8.3102 17.0597 7.92056 16.821 7.68024C16.5824 7.43992 16.1954 7.43992 15.9568 7.68024L9.66667 14.0143L7.04323 11.3725Z",
    fill: "#D8D8D8",
    stroke: "#D8D8D8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.0a5cb9818a9c766c14e383192f323c2a.svg";
export { ForwardRef as ReactComponent };